import React from 'react';
import classNames from 'classnames';
import { ContentContainerEnum, FlexDirectionEnum } from '@/enums/styling';
import { getTailwindClassesByEnum } from '@/utils/cssHelpers';
import { compose } from '@/utils/story-composer';
import LinkComponent from '@/components/elements/link-component';

function ContentContainer({
	content,
	flexDirection = '',
	mobileFlexDirection = '',
	flexGrow,
	hasShadow,
	link,
	hoverColor = '',
	activeColor = '',
	backgroundColor = '',
	alignment = [],
	margin = [],
	padding = [],
	borderRadius = [],
	visibility = [],
	customStyling,
	elementProps,
}) {
	let flexClasses = FlexDirectionEnum[flexDirection] || '';
	if (mobileFlexDirection && flexDirection) {
		flexClasses = `${FlexDirectionEnum[mobileFlexDirection]} md:${FlexDirectionEnum[flexDirection]}`;
	}

	const componentProperties = [
		backgroundColor,
		hoverColor,
		activeColor,
		...borderRadius,
		...alignment,
		...margin,
		...padding,
		...visibility,
	];

	const tailWindClasses = getTailwindClassesByEnum(ContentContainerEnum, componentProperties);
	const overflowHidden = borderRadius.length > 0 ? 'overflow-hidden' : '';

	const renderContentContainer = () => (
		<div
			className={classNames(
				'flex self-stretch sm:self-auto',
				overflowHidden,
				tailWindClasses,
				flexClasses,
				flexGrow && 'flex-grow',
				hasShadow && 'shadow-[inset_0_-2px_rgba(0,0,0,0.2)] active:shadow-none',
				customStyling
			)}
			{...elementProps}
		>
			{content}
		</div>
	);

	const renderContentContainerWithLink = () => <LinkComponent link={link}>{renderContentContainer()}</LinkComponent>;

	const hasClickAction = link && (link.id !== '' || link.url !== '');
	return hasClickAction ? renderContentContainerWithLink() : renderContentContainer();
}

export default ContentContainer;
compose('content-container', ContentContainer, { children: ['content'] });
